import Navigation from "./navigation";
import Footer from "./footer";
import goal from "../assets/images/goal.png";
import chairty from "../assets/images/charity.png";
import community from "../assets/images/community.png";
import confrence from "../assets/images/conference.png";
// import renis from "./images/ren1 (36).jpg";
import renisnew from "./images/rennew.jpg";
// import renisfamily from "./images/renisfamily.jpg";
// import renis2 from "../assets/images/renis2.png";
// import renvideo from "./images/renvideo.mp4";
// import renaudio from "./images/renaudio.mp3";
import quotesicon from "../assets/images/quotesicon.png";
// import renbgrm2 from "./images/renbgrm2.png";
// import renbgrm from "./images/renbgrm.png";
// import newbg from "../images/newbg.webp";
import MySlider from "./mySlider";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import LatestEventsSection from "./LatestEventsSection";
import LatestBlogsSection from "./LatestBlogsSection";
import redirectToDonation from "./donationRedirect";
import DonateShirt from "./DonateShirt";
import { fetchVideos, fetchCountdowns } from "./api";
import VideoPlayer from "./VideoPlayer";
import CountdownItem from "./CountdownItem";
import EndorsementsSection from "./EndorsementsSection";

// import { useParams } from "react-router-dom";

const Home = () => {
  const [videos, setVideos] = useState([]);
  const [countdowns, setCountdowns] = useState([]);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  // Magellan AI Pixel - Lead event (homepage only)
  useEffect(() => {
    (function (w, d, n) {
      if (w.MAI) return;
      w.MAI = w.MAI || { emit: function () { (w.MAI.q = w.MAI.q || []).push(arguments); } };
      var e = d.createElement(n); e.async = 1;
      e.src = "https://cdn.mgln.ai/pixel.min.js";
      var s = d.getElementsByTagName(n)[0];
      s.parentNode.insertBefore(e, s);
    })(window, document, "script");
    window.MAI.emit("conf", "019e6646a50373eb845b79453374520c");
    window.MAI.emit("lead", 0, "USD");
  }, []);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const c = await fetchCountdowns();
        if (mounted && Array.isArray(c)) {
          const now = new Date();
          const activeCountdowns = c
            .filter((item) => item.is_active && new Date(item.end_date) > now)
            .sort((a, b) => new Date(a.end_date) - new Date(b.end_date));
          setCountdowns(activeCountdowns);
        }

        const v = await fetchVideos();
        if (mounted) setVideos(v.slice(0, 3)); // latest 3
      } catch (e) {
        // ignore
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="overflow-x-hidden">
      <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
      <div className="w-full min-h-[70vh] sm:min-h-[75vh] md:min-h-[80vh] max-h-[600px] sm:max-h-[700px] md:max-h-[800px] flex items-center justify-center relative px-4 sm:px-6 md:px-8 lg:px-12 overflow-hidden">
        <img src="https://backend.ren4misenate.com/media/event_images/newbg.webp" alt="Background" className="absolute inset-0 w-full h-full object-cover" style={{zIndex:0}} />
        <div className="absolute inset-0" style={{backgroundColor: 'rgba(0,0,0,0.35)', zIndex:1, pointerEvents: 'none'}} />
        <div className="max-w-7xl mx-auto w-full relative z-20">
          <div className="flex flex-col items-start text-white text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight sm:leading-snug md:leading-normal">
              People over politics
            </h1>
            <p className="mt-3 sm:mt-4 md:mt-6 text-lg sm:text-xl md:text-2xl text-white opacity-90">
              Are you ready?
            </p>
            <Link
              to="/ren on issue"
              className="mt-6 sm:mt-8 md:mt-10 inline-block px-5 py-2.5 sm:px-6 sm:py-3 md:px-8 md:py-4 bg-white text-sm sm:text-base md:text-lg font-medium rounded-md hover:bg-gray-100 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
              style={{ color: "var(--primary)" }}
            >
              Our Top Priorities
            </Link>
          </div>
        </div>
      </div>
      <div className="max-width" style={{position: 'relative', zIndex: 30}}>
        
        <div className="stats-bar">
          <div className="status-card">
            <Link to="/about">
              <img src={goal} alt="" />
            </Link>
            <Link to="/about">
              <div>Our Mission</div>
            </Link>
          </div>
          <div className="status-card">
            <Link to="/events">
              <img src={confrence} alt="" />
            </Link>
            <Link to="/events">
              <div>Campaign Events</div>
            </Link>
          </div>
          <div className="status-card">
            <Link to="https://secure.actblue.com/donate/ren4mi">
              <img src={chairty} alt="" />
            </Link>
            <Link to="https://secure.actblue.com/donate/ren4mi">
              <div>Donate</div>
            </Link>
          </div>
          <div className="status-card">
            <Link to="/home">
              <img src={community} alt="" />
            </Link>
            <Link to="/home">
              <div>Join Us</div>
            </Link>
          </div>
        </div>

       
        {/* <div className="section-margin-half"></div> */}
        <div className="horizontal gap-20 mb-vertical">
          <img
            src={renisnew}
            alt=""
            className="home-about-us-image1 full-width"
            style={{ height: "500px" }}
          />
          <div className="home-about-section-text">
            <p style={{ color: "var(--primary)" }}>Ren Nushaj</p>
            <h2 className="about-big-text">
              Democrat for Michigan State Senate – District 9
            </h2>
            <p className="about-description">
              We need new people willing to step forward and meet this
              unprecedented moment. We need fighters. We need advocates. We need
              people who understand that public service means putting the people
              over politics and principle above personal ambition.
            </p>

            <audio
              src="https://backend.ren4misenate.com/media/media_files/renaudio.mp3"
              className="hidden renaudioclass"
              controls
            ></audio>
            <div className="horizontal gap-10">
              {/* <a href={renaudio} className="btn-primary-primary">Download </a> */}
              <Link to={"/about"}>
                <button className="btn-primary-primary">Learn More </button>
              </Link>
            </div>
          </div>
        </div>


 {/* <div className="section-margin-half hide-mobile"></div> */}
      <div className="section-margin hide-mobilea"></div>
      
        {countdowns.length > 0 && (
          <div className="max-w-7xl mx-auto">
            <div className="donate-ornage-section mb-8 py-6 px-8">
              <div className="flex flex-wrap justify-center gap-8 w-full">
                {countdowns.map((countdown) => (
                  <div
                    key={countdown.id}
                    className="w-full md:w-[45%] flex justify-center"
                  >
                    <CountdownItem countdown={countdown} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      <div className="max-width w-full">
        <div className="section-margin"></div>
        <div className="renquote px-4 sm:px-6 md:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 md:gap-12 lg:gap-16 xl:gap-20">
            <div className="renis-quote-section-text order-2 lg:order-1 w-full lg:w-1/2">
              <img
                src={quotesicon}
                alt="Quote icon"
                className="h-20 sm:h-24 md:h-28 lg:h-32 xl:h-36 mb-4 sm:mb-6 md:mb-8 pl-4 sm:pl-6 md:pl-8 lg:pl-10"
                style={{ color: "var(--primary)" }}
              />

              <q className="block text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed sm:leading-loose text-gray-700 italic pl-4 sm:pl-6 md:pl-8 lg:pl-10">
                The decision to run for office is never simple. It demands
                sacrifice, commitment, and resolve, not only from the candidate,
                but from the entire community. Yet it is also an act of hope, an
                affirmation that democracy still belongs to we the people, and
                that service to others is the highest calling. I am running for
                Michigan Senate, not only to voice our objections, but to build
                solutions, to lead change, and to deliver the results this
                community desperately needs.
              </q>

              <h2 className="font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl pl-4 sm:pl-6 md:pl-8 lg:pl-10 mb-3 sm:mb-4 md:mb-6">
                Ren Nushaj
              </h2>
            </div>

            <div className="order-1 lg:order-2 w-full lg:w-1/2">
              <img
                src="https://backend.ren4misenate.com/media/blog_images/renisfamily.jpg"
                alt="Ren Nushaj and family"
                className="w-full h-64 sm:h-72 md:h-80 lg:h-96 xl:h-[500px] rounded-lg shadow-lg object-cover object-center border-4 p-2"
                style={{
                  borderColor: "var(--primary)",
                  boxShadow:
                    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <DonateShirt />
  
  

        <div className="section-margin"></div>
        <div className="mission-vision px-4 sm:px-6 lg:px-8">
          <div className="sup-heading text-center text-sm md:text-base lg:text-lg">
            Mission And Vision
          </div>
          <div className="section-heading-mission margin-center text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold">
            Build a better country together!
          </div>
          <div
            className="text-center mx-auto px-4 mb-6 sm:mb-8 md:mb-10"
            style={{
              textAlign: "center",
              fontSize: "16px sm:text-lg",
              color: "#333",
              maxWidth: "600px",
            }}
          >
            We elect our state senator to keep our families safe, to strengthen
            our economy, to help our community thrive. These are sacred
            responsibilities. That's why I'm running. Ren Nushaj.
          </div>

          <div className="mission-vision-card-container max-w-6xl mx-auto">

            <div className="mission-card">
              <i className="bi bi-eye-slash text-2xl sm:text-3xl md:text-4xl"></i>
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
                Privacy
              </h2>
              <div className="text-sm sm:text-base">
                Fighting against surveillance cameras and drones and seeking a
                moratorium on data centers in order to protect our rights.
              </div>
            </div>
            <div className="mission-card">
              <i className="bi bi-graph-up-arrow text-2xl sm:text-3xl md:text-4xl"></i>
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
                Economy
              </h2>
              <div className="text-sm sm:text-base">
                Focused on the economy, through investments in education,
                healthcare, and infrastructure - not just in name, but in
                dollars and action.
              </div>
            </div>
            <div className="mission-card">
              <i className="bi bi-piggy-bank text-2xl sm:text-3xl md:text-4xl"></i>
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
                Earned Benefits
              </h2>
              <div className="text-sm sm:text-base">
                Fighting to protect our seniors and protect their hard earned
                Social Security, Medicare and Safety Net Programs.
              </div>
            </div>
            <div className="mission-card">
              <i className="bi bi-cart-check text-2xl sm:text-3xl md:text-4xl"></i>
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
                Cost of Living
              </h2>
              <div className="text-sm sm:text-base">
                Fighting to bring prices down, cap costs on essentials like gas,
                groceries, and prescriptions, and make sure our economy works.
              </div>
            </div>
            <div className="mission-card">
              <i className="bi bi-shield-check text-2xl sm:text-3xl md:text-4xl"></i>
              <h2 className="text-lg sm:text-xl md:text-2xl font-semibold">
                Public Safety
              </h2>
              <div className="text-sm sm:text-base">
                Standing up for Public Safety, supporting our police, our
                firefighters, and all who protect us.
              </div>
            </div>
          </div>
        </div>

            {/* Endorsements */}
            
        <div className="section-margin"></div>
        <div className="section-margin"></div>
            <EndorsementsSection />

        <div className="section-margin"></div>
      </div>
      <LatestEventsSection count={3} />
    

      <div className="section-margin hide-mobilea"></div>
      <div className="stats-section px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="max-width">
          <div className="video-text-container">
            {/* <div className="sup-heading text-center">Our Videos</div> */}
            <div className="section-heading margin-center text-center text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold">
              Our Media
            </div>
            
            {/* Mobile View - Single Video with Pagination */}
            <div className="md:hidden">
              <div className="flex justify-center mb-6 sm:mb-8 md:mb-10">
                {videos.length > 0 && (
                  <VideoPlayer key={videos[currentVideoIndex].id} video={videos[currentVideoIndex]} showTitle={true} />
                )}
              </div>
              
              {videos.length > 1 && (
                <div className="flex justify-center items-center gap-4 sm:gap-6 mb-6 sm:mb-8">
                  <button
                    onClick={() => setCurrentVideoIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1))}
                    className="p-2 sm:p-3 bg-white rounded-full hover:bg-gray-200 transition-all duration-300"
                    aria-label="Previous video"
                  >
                    <i className="bi bi-chevron-left text-lg sm:text-xl" style={{ color: "var(--primary)" }}></i>
                  </button>
                  
                  <span className="text-white text-sm sm:text-base">
                    {currentVideoIndex + 1} / {videos.length}
                  </span>
                  
                  <button
                    onClick={() => setCurrentVideoIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1))}
                    className="p-2 sm:p-3 bg-white rounded-full hover:bg-gray-200 transition-all duration-300"
                    aria-label="Next video"
                  >
                    <i className="bi bi-chevron-right text-lg sm:text-xl" style={{ color: "var(--primary)" }}></i>
                  </button>
                </div>
              )}
            </div>

            {/* Desktop View - Grid */}
            <div className="hidden md:block">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mt-6 sm:mt-8 md:mt-10 mb-6 sm:mb-8 md:mb-10">
                {videos.map((video) => (
                  <VideoPlayer key={video.id} video={video} showTitle={true} />
                ))}
              </div>
            </div>

            <div className="max-width full-width text-center flex flex-col items-center gap-6 sm:gap-10 md:gap-12 lg:gap-16">
              <Link
                to="/media"
                className="btn-primary-primary text-sm sm:text-base md:text-lg font-medium py-3 sm:py-4 px-6 sm:px-8 md:px-10 lg:px-12 min-w-[150px] sm:min-w-[180px] md:min-w-[200px]"
              >
                View All MEDIA
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="section-margin"></div>

      <div className="max-width overflow-hidden">
        <div className="donate-ornage-section mb-vertical space-between justify-between">
          <div className="text-center text-white sm:text-left text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold">
            Donate to Our Campaign.
          </div>
          <div className="horizontal ">
            <button
              className="jose donate-btn-white"
              style={{ width: 150, padding: 15 }}
              onClick={redirectToDonation}
            >
              Donate Now
            </button>
          </div>
        </div>
      </div>

      <div className="section-margin"></div>

     <div className="homepage-blogs-section">
  <LatestBlogsSection count={3} />
  <div className="blogs-section-spacing"></div>
  <Link
          to="/news"
          className="btn-primary-primary px-6 sm:px-8 md:px-10 py-3 sm:py-4 text-sm sm:text-base md:text-lg font-medium rounded-lg hover:bg-blue-700 transition-colors duration-300 w-fit mx-auto"
        >
          View All Blogs
        </Link>
</div>

      <div className="section-margin"></div>

      <div className="max-width overflow-hidden">
        <div className="donate-ornage-section sms-cta-section mb-vertical space-between justify-between">
          <div className="text-center text-white sm:text-left text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold">
            Get Campaign Updates by Text.
          </div>
          <div className="horizontal">
            <Link
              to="/sms-opt-in"
              className="jose donate-btn-white"
              style={{ width: 150, padding: 15 }}
            >
              Sign Me Up
            </Link>
          </div>
        </div>
      </div>

      <div className="section-margin"></div>

      <div className="events-containera">
        <div className="max-width full-width vertical gap-20">
          <div className="sup-heading text-center">Work</div>
          <div className="section-heading margin-center text-center">
            In the Community
          </div>
        </div>
      </div>

      <MySlider />

      <div className="section-margin"></div>
      <div className="section-margin"></div>

      <Footer />
    </div>
  );
};

export default Home;
